import colors from '@magoosh/lib/styles/colors.module.scss';

export default (examName: string, sections: string) => {
  if (examName === 'GMAT') {
    if (!sections || sections === 'all') {
      return [
        { color: colors.gray85, label: 'Quantitative Reasoning', value: 60 },
        { color: colors.grayLighter, label: 'Verbal Reasoning', value: 30 },
        { color: colors.gray75, label: 'Data Insights', value: 30 }
      ];
    }

    let result = [];

    if (sections.indexOf('quantitative_reasoning') !== -1){
      result.push({ color: colors.gray85, label: 'Quantitative Reasoning', value: 60 });
    }
    if (sections.indexOf('verbal_reasoning') !== -1) {
      result.push({ color: colors.grayLighter, label: 'Verbal Reasoning', value: 30 });
    }
    if (sections.indexOf('data_insights') !== -1) {
      result.push({ color: colors.gray75, label: 'Data Insights', value: 30 });
    }

    return result;
  } else if (examName === 'GRE') {
    if (!sections || sections === 'all') {
      return [
        { color: colors.gray85, label: 'Math', value: 60 },
        { color: colors.grayLighter, label: 'Verbal', value: 30 }
      ];
    }

    let result = [];

    if (sections.indexOf('math') !== -1){
      result.push({ color: colors.gray85, label: 'Math', value: 60 });
    }
    if (sections.indexOf('verbal') !== -1) {
      result.push({ color: colors.grayLighter, label: 'Verbal', value: 30 });
    }

    return result;
  }
};
